/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsRepeatH: {
  name: 'arrows-repeat-h';
  data: string;
} = {
  name: 'arrows-repeat-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L5.414 7H20v4a1 1 0 1 0 2 0V7a2 2 0 0 0-2-2H5.414l1.293-1.293Zm15 15a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.414 1.414L18.586 17H4v-4a1 1 0 1 0-2 0v4a2 2 0 0 0 2 2h14.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3Z" fill="currentColor"/></svg>`,
};
